/**
 * Translates a text query as a regexp compatible string, and tests it
 * against a string value. It only handles wildcards '*'. 
 * Adds '^' and '$' respectively at the beginning and end of the regex 
 * strng and replaces '*' by '.*'. (ex : '*foo*' => '^.*foo.*$')
 * Returns a boolean indicating whether or not the text matches the regex or not
 * @param regexTxt 
 * @param text 
 */
export function matchesRegex(regexTxt: string, text: string) {
    regexTxt = "^" + regexTxt.split('*').join('.*') + "$";
    return !!text.match(regexTxt);
}